import Carousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
import ClassNames from 'embla-carousel-class-names';
import Fade from 'embla-carousel-fade';

// Down button scroll
const down = document.querySelector('.down');

if (down) {
  down.addEventListener('click', () => {
    const newProducts = document.querySelector('.new-products');

    if (newProducts) {
      window.scrollTo({
        top: newProducts.offsetTop - 16,
        behavior: 'smooth'
      });
    }
  });
}

const carouselNodes = Array.from(document.querySelectorAll('.carousel'));

if (document.querySelector('.carousel')) {

  const createCarousel = (node, plugins) => {
    const viewport = node.querySelector('.carousel--viewport');
    const loop = node.dataset.loop === 'true' ? true : false;
    const slidesToScroll = node.dataset.slideToScroll;

    const carousel = Carousel(viewport, {
      align: 'start',
      loop,
      slidesToScroll,
      containScroll: 'trimSnaps',
      speed: 5,
      draggable: true,
      watchResize: true
    }, plugins);

    const selectDotBtn = (dotsArray, embla) => () => {
      const previous = embla.previousScrollSnap();
      const selected = embla.selectedScrollSnap();
      dotsArray[previous].classList.remove('is-selected');
      dotsArray[selected].classList.add('is-selected');
    };

    const dots = node.querySelector('.carousel--dots');

    if (dots) {
      const setupDotBtns = (dotsArray, embla) => {
        dotsArray.forEach((dotNode, i) => {
          dotNode.addEventListener('click', () => embla.scrollTo(i), false);
        });
      };

      const generateDotBtns = (dots, embla) => {
        const button = '<button type="button" class="carousel--dot" aria-label="Scroll to slide"><span class="sr-only">Scroll to slide</span></button>';
        dots.innerHTML = embla.scrollSnapList().reduce(acc => acc + button, '');
        return Array.from(dots.querySelectorAll('.carousel--dot'));
      };

      const dotsArray = generateDotBtns(dots, carousel);
      const setSelectedDotBtn = selectDotBtn(dotsArray, carousel);

      setupDotBtns(dotsArray, carousel);

      carousel.on('select', setSelectedDotBtn);
      carousel.on('init', setSelectedDotBtn);
    }

    const prevBtn = node.querySelector('.carousel--prev');
    const nextBtn = node.querySelector('.carousel--next');

    if (prevBtn && nextBtn) {
      const setupNavButtons = (prevBtn, nextBtn, embla) => {
        prevBtn.addEventListener('click', () => embla.scrollPrev(), false);
        nextBtn.addEventListener('click', () => embla.scrollNext(), false);
      };

      setupNavButtons(prevBtn, nextBtn, carousel);
    }


    const toggleEmblaReady = event => {
      const isResizeEvent = event === 'resize';
      const toggleClass = isResizeEvent ? 'remove' : 'add';
      viewport.classList[toggleClass]('carousel--is-ready');
      if (isResizeEvent) carousel.reInit();
    };

    carousel.on('init', toggleEmblaReady);
    carousel.on('resize', toggleEmblaReady);
    carousel.on('reInit', toggleEmblaReady);
  };

  const autoplayOptions = {
    delay: 7000,
    stopOnInteraction: false,
    stopOnMouseEnter: true
  };

  const classnameOptions = {
    snapped: 'is-active',
    draggable: 'cursor-grab',
    dragging: 'cursor-grabbing'
  };

  carouselNodes.forEach(node => {
    createCarousel(node, [
      ClassNames(classnameOptions),
      node.dataset.autoplay === 'true' ? Autoplay(autoplayOptions) : null,
      node.dataset.fade === 'true' ? Fade() : null
    ].filter(Boolean));
  });
}

if (document.querySelector('.carousel-video--wrapper.lazyload')) {
  document.addEventListener('DOMContentLoaded', function() {
    const lazyVideos = [].slice.call(document.querySelectorAll('.carousel-video--wrapper.lazyload'));

    if ('IntersectionObserver' in window) {
      const lazyVideoObserver = new IntersectionObserver(function(entries) {
        entries.forEach(video => {
          if (video.isIntersecting) {
            const source = video.target.dataset.src;
            const title = video.target.dataset.title;
            const facade = video.target.querySelector('.facade');
            const iframe = document.createElement('iframe');
            iframe.setAttribute('src', `https://player.vimeo.com/video/${source}?autoplay=1&loop=1&autopause=0&muted=1&background=1`);
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'autoplay');
            iframe.setAttribute('loading', 'lazy');
            iframe.setAttribute('title', title);
            iframe.classList.add('carousel-video--iframe', 'no-pointer');
            video.target.appendChild(iframe);

            if (facade) {
              setTimeout(() => {
                facade.remove();
              }, 1000);
            }

            lazyVideoObserver.unobserve(video.target);
          }
        });
      });

      lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }

  });
}
